export function initStickyHeader() {
    var navigation = document.querySelector(".block--simple-navigation");
    var heroProject = document.querySelector(".block.block--hero-project");
    var contactButton = navigation && navigation.querySelector(".simple-navigation__contact");

    if (!navigation || !heroProject) {
        return;
    }

    var setSticky = function (isSticky) {
        navigation.classList.toggle("is-sticky", isSticky);

        if (contactButton) {
            contactButton.classList.toggle("btn-primary", isSticky);
            contactButton.classList.toggle("btn-secondary--outline", !isSticky);
        }
    };

    var observer = new IntersectionObserver(function (entries) {
        var entry = entries[0];
        // Sticky only when scrolled past the hero (above viewport), not when below it
        var scrolledPast = !entry.isIntersecting && entry.boundingClientRect.bottom <= 0;
        setSticky(scrolledPast);
    });

    observer.observe(heroProject);
}